import React from "react";

import { Navigate } from "react-router-dom";

import ROUTES from "@app/common/routes";

const AccessRedirect = ({
  children,
  hasAccess,
  redirectTo,
}: {
  children: React.ReactNode;
  hasAccess: boolean;
  redirectTo?: string;
}) => {
  if (hasAccess) {
    return <>{children}</>;
  }

  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Navigate to={ROUTES.MEETING_REPORTS} replace />;
};

export default AccessRedirect;
